(function() {
  'use strict';

  function Controller($rootScope, $scope, $log, Profile,
                      EventUtils, $translate, Utils, Auth) {
    var ctrl = this;

    var addTag = function(item) {
      var extra = {
        blueprints: ctrl.model.selected,
        tags: []
      };

      item.addExtra(extra)
        .then(function() {
          return item.reload();
        })
        .then(function() {
          $scope.$broadcast('kzReloadActions');

          // Utils.swal({
          //   title: 'Nice!',
          //   text: 'Tags have been applied',
          //   type: 'success',
          //   showConfirmButton: false,
          //   timer: 500
          // });
        })
        .catch(function(err) {
          Utils.showError(err);
        });
    };

    ctrl.$onInit = function() {
      var listName = 'events';
      ctrl.options = {
        highlightField: 'name',
        trackBy: 'id',
        borderClass: function(item) {
          return item.main.getBorderClass();
        }
      };
      ctrl.username = Auth.currentUser();

      ctrl.prefs = Profile.getPreferences();
      ctrl.model = _.assignIn({
        selected: []
      }, ctrl.prefs.bulkTagging || {});

      ctrl.searchModel = Profile.getListPreferences(listName).current;
      ctrl.options.search = ctrl.searchModel;

      EventUtils.getList('dbsearch', ctrl.searchModel,
                        { resolvedFilter: ctrl.resolvedFilter, own: true }
      )
        .then(function(list) {
          ctrl.list = list;
          ctrl.list.doLoadItems();
          $rootScope.$broadcast('KZCurrentListChange', { list: listName, search: list.search });
          $rootScope.loading = false;
          ctrl.loaded = true;
        })
        .catch(function(error) {
          $rootScope.loading = false;
          ctrl.loaded = true;
          $log.warn(error);
        });

      ctrl.actions = [
        {
          label: $translate.instant('Select tags'),
          icon: 'icon-edit',
          route: ['events', 'select'],
          klass: 'btn-success'
        },
        {
          label: $translate.instant('Exit bulk tagging'),
          icon: 'icon-cancel',
          route: ['events', 'list'],
          klass: 'btn-warning'
        }
      ];

      // Override event default buttons
      ctrl.options.actionButtons = function(item) {
        return [
          {
            label: $translate.instant('Apply tags'),
            icon: 'icon-edit',
            onClick: addTag.bind(this, item),
            showCondition: function() {
              if (_.difference(ctrl.model.selected, item.categories).length === 0) {
                return false;
              }

              return true;
            },
            klass: 'text-info'
          },
          {
            label: $translate.instant('Tags already applied'),
            icon: 'icon-edit',
            labelOnly: true,
            showCondition: function() {
              return _.difference(ctrl.model.selected, item.categories).length === 0;
            },
            klass: 'text-info'
          }
        ];
      };
    };
  }

  Controller.$inject = [
    '$rootScope',
    '$scope',
    '$log',
    'ProfileService',
    'EventUtils',
    '$translate',
    'UtilsService',
    'AuthService'
  ];

  angular.module('component.events')
    .component('applyTagsComponent', {
      controller: Controller,
      controllerAs: 'eventsCtrl',
      templateUrl: 'app/components/events/applytags.html'
    });
})();
